import { jwtDecode } from 'jwt-decode';

const auth = JSON.parse(localStorage.getItem('token'));
let decoded = '';
if (auth) {
  decoded = jwtDecode(auth);
}
// eslint-disable-next-line import/no-mutable-exports
let TABLE_HEAD = [];

if (decoded?.location === 'Georgia') {
  TABLE_HEAD = [
    { id: 'tracking', label: 'Tracking', width: 380 },
    { id: 'airway_date', label: 'Land Date', width: 380 },
    { id: 'created_at', label: 'created_at', width: 380 },
    { id: 'BranchAWB', label: 'Branch', width: 380 },
    { id: 'status', label: 'Status', width: 100 },
    { id: '', width: 100 },
  ];
} else if (decoded?.location === 'China') {
  TABLE_HEAD = [
    { id: 'tracking', label: 'Tracking', width: 380 },
    { id: 'airway_date', label: 'Land Date', width: 380 },
    { id: 'created_at', label: 'created_at', width: 380 },
    { id: 'BranchAWB', label: 'Branch', width: 380 },
    { id: 'status', label: 'Status', width: 100 },
    { id: '', width: 100 },
  ];
} else {
  TABLE_HEAD = [
    { id: 'tracking', label: 'Tracking', width: 380 },
    { id: 'airway_date', label: 'Land Date', width: 380 },
    { id: 'created_at', label: 'created_at', width: 380 },
    { id: 'status', label: 'Status', width: 100 },
    { id: '', width: 100 },
  ];
}

const defaultFilters = {
  name: '',
  role: [],
};
// eslint-disable-next-line import/no-mutable-exports
let tableNames = [];

if (decoded?.location === 'Georgia') {
  tableNames = [
    { id: 'tracking', label: 'Tracking' },
    { id: 'airway_date', label: 'Land Date' },
    { id: 'created_at', label: 'created_at' },
    { id: 'BranchAWB', label: 'branch' },
    { id: 'status', label: 'Status' },
  ];
} else if (decoded?.location === 'China') {
  tableNames = [
    { id: 'tracking', label: 'Tracking' },
    { id: 'airway_date', label: 'Land Date' },
    { id: 'created_at', label: 'created_at' },
    { id: 'BranchAWB', label: 'branch' },
    { id: 'status', label: 'Status' },
  ];
} else {
  tableNames = [
    { id: 'tracking', label: 'Tracking' },
    { id: 'airway_date', label: 'Land Date' },
    { id: 'created_at', label: 'created_at' },
    { id: 'status', label: 'Status' },
  ];
}
const status = ['AWAITING', 'ON AIR', 'LANDED'];

const personalInformation = [
  {
    name: 'name',
    width: '97%',
    label: 'Name',
  },
  {
    name: 'tracking',
    width: '97%',
    label: 'Tracking',
  },
];

const status_colors = {
  ACTIVE: ['#22C55E29', '#118D57'],
  INACTIVE: ['#919EAB29', '#637381'],
};

export { TABLE_HEAD, defaultFilters, tableNames, status, personalInformation, status_colors };
